import { AttributesMixin, define, Model } from "@type-r/models";

export interface AssetTypeItem extends AttributesMixin<typeof AssetTypeItem> { }
@define
export class AssetTypeItem extends Model {
    static attributes = {
        name: String
    }
}